// extracted by mini-css-extract-plugin
module.exports = {"productImage":"ProductImage_productImage__91Mg8"};